import { finance, readyToOpen } from "../data";
/**
 * @param {Phaser.Scene} scene
 * @param {Phaser.Physics.Arcade.Sprite} chest
 */
export const createChest = (scene, scaleX, width, height) => {
  let warning = scene.add.group([
    scene.add
      .image(width / 2, height - 70 * scaleX, "longBar")
      .setDisplaySize(400 * scaleX, 150 * scaleX),
    scene.add
      .text(width / 2, height - 70 * scaleX, "Not Enough Coins!", {
        fontFamily: "Grooving",
        fontSize: "30px",
      })
      .setOrigin(0.5)
      .setScale(scaleX),
  ]);
  warning.setDepth(2).setVisible(false);
  let chest = scene.physics.add
    .sprite(0, 0, "chestClosed")
    .setOrigin(0.2, 0.7)
    .setScale(0.25 * scaleX)
    .setInteractive()
    .on("pointerdown", () => {
      if (finance.coins >= 50) {
        readyToOpen.value = true;
      } else {
        warning.setVisible(true);
        scene.time.delayedCall(3000, () => {
          warning.setVisible(false);
        });
      }
    })
    .setVisible(false);
  return chest;
};
export const moveChest = (
  chestRotatePos,
  chestRotateNeg,
  chestMoveUp,
  chestMoveDown,
  chest,
  chestMoveUpLimit,
  chestMoveDownLimit,
  scaleX
) => {
  if (chestRotatePos) {
    chest.setAngle(chest.angle + 0.3);
    if (chest.angle >= 15) {
      chestRotatePos = false;
      chestRotateNeg = true;
    }
  }
  if (chestRotateNeg) {
    chest.setAngle(chest.angle - 0.3);
    if (chest.angle <= -20) {
      chestRotatePos = true;
      chestRotateNeg = false;
    }
  }
  if (chestMoveUp) {
    chest.body.setVelocityY(-5 * scaleX);
    if (chest.y <= chestMoveUpLimit) {
      chestMoveUp = false;
      chestMoveDown = true;
    }
  }
  if (chestMoveDown) {
    chest.body.setVelocityY(5 * scaleX);
    if (chest.y >= chestMoveDownLimit) {
      chestMoveUp = true;
      chestMoveDown = false;
    }
  }
  return [chestRotatePos, chestRotateNeg, chestMoveUp, chestMoveDown];
};

/**
 * @param {Phaser.Scene} scene
 * @param {Phaser.Physics.Arcade.Sprite} chest
 */
export const openChest = (scene, chest, width, scaleX) => {
  let x = 70;
  let n = 0;
  chest.setVelocityY(0);
  chest.setVelocityX(x);
  var timer = scene.time.addEvent({
    delay: 90,
    callback: () => {
      x = -1.1 * x;
      if (n >= 18) {
        timer.destroy();
        chest.setVelocityX(0);
        finance.coins -= 50;
        chest.play("chest");
        scene.sound.play("unlockClick");
        let circle = scene.add
          .circle(
            scene.chest.x + 20 * scaleX,
            scene.chest.y - 20 * scaleX,
            0,
            0xf2a900
          )
          .setDepth(3);
        scene.time.delayedCall(700, () => {
          scene.time.addEvent({
            delay: 16,
            callback: () => {
              if (circle.radius >= width / 2 + 100 * scaleX) {
                scene.scene.start("slot");
              }
              circle.radius += 10;
            },
            callbackScope: scene,
            repeat: -1,
            loop: true,
          });
        });
      } else {
        chest.setVelocityX(x);
      }
      n++;
    },
    callbackScope: scene,
    repeat: -1,
  });
};
